import {Box, Button, IconButton, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import {Field, Form, Formik, useFormikContext} from "formik";
import {FormControl, Grid, InputLabel, MenuItem, Select, TextField} from "@material-ui/core";
import {REGIONS} from "../../utils/META/cat_101";
import EditIcon from "@material-ui/icons/Edit";

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(4),
        display:'flex',
        justifyContent:'center',
        minHeight:'83vh',
        flexDirection:'column',
    },
    actionButton: {
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff !important',
        borderRadius: '20px !important',
        fontSize: '15px !important',
        padding: '6px 35px !important',
        textAlign:'center !important',
        marginRight: theme.spacing(1),
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",        },

    },
    infoTitle: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'left',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '32px !important',
        },
    },
}));

const FormTextField = ({ label, name, value, disabled, ...rest }) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <Field
            style={{backgroundColor:'#fff'}}
            as={TextField}
            label={isFocused ? '' : label}
            name={name}
            fullWidth
            required
            margin="normal"
            variant="outlined"
            InputLabelProps={{
                shrink: value ? true : isFocused,
            }}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            disabled={disabled}
            {...rest}
        />
    );
};

const FormSelect = ({ label, name, options, disabled }) => (
    <FormControl fullWidth variant="outlined" margin="normal" required disabled={disabled} style={{backgroundColor:'#fff'}}>
        <InputLabel htmlFor={name}>{label}</InputLabel>
        <Field as={Select} label={label} name={name}>
            {options.map((option, index) => (
                <MenuItem key={index} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </Field>
    </FormControl>
);

const FormComponent = ({ organizationInfo, isGuestUser, handleCompanyDataChange, isEditing, signUpAction }) => {
    const classes = useStyles();
    const { values, setFieldValue } = useFormikContext();

    // useEffect(() => {
    //     if (handleCompanyDataChange) {
    //         handleCompanyDataChange(values);
    //     }
    // }, [values, handleCompanyDataChange]);

    return (
        <Form>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <FormTextField
                        label="Name of organization"
                        name="NameOrg"
                        value={values.NameOrg}
                        disabled={!isEditing || isGuestUser}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormSelect
                        label="Country of organization’s headquarters"
                        name="Region"
                        options={REGIONS}
                        value={values.Region}
                        disabled={!isEditing || isGuestUser}
                    />
                </Grid>
            </Grid>
            {isGuestUser ? (
                <Box textAlign="center" mt={4}>
                    <Typography variant="h5" gutterBottom>
                        Please sign up to access billing information.
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            signUpAction();
                        }}
                        className={classes.actionButton}
                    >
                        Sign Up
                    </Button>
                </Box>
            ) : (
                <>
            <Box mt={5}>
                <Typography variant="h4" component="h1" gutterBottom className={classes.infoTitle}>
                    Billing Information
                </Typography>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <FormTextField label="Name of company" name="nameCompany" variant="outlined" fullWidth value={values.nameCompany} disabled={!isEditing}  />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormTextField label="Address of company" name="addressCompany" variant="outlined" fullWidth value={values.addressCompany} disabled={!isEditing} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormTextField label="Contact number of company" name="contactCompany" variant="outlined" fullWidth value={values.contactCompany} disabled={!isEditing} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormTextField label="Name of contact person" name="nameContactPerson" variant="outlined" fullWidth value={values.nameContactPerson} disabled={!isEditing} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormTextField label="Email of contact person" name="emailContactPerson" variant="outlined" fullWidth value={values.emailContactPerson} disabled={!isEditing} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormTextField label="Contact number of contact person" name="contactContactPerson" variant="outlined" fullWidth value={values.contactContactPerson} disabled={!isEditing} />
                </Grid>
            </Grid>
            <Box mt={2} style={{textAlign:'center'}}>
                <Button className={classes.actionButton} type="submit" variant="contained" color="primary" disabled={!isEditing}>
                    Save
                </Button>
            </Box>
                </>
            )}
        </Form>
    );
};


const AccountInformation = ({ data, actions, options }) => {
    const classes = useStyles();

    const { defaultInitialValues } = data;
    const { companyInfoUpdateAction, signUpAction } = actions;
    const { isGuestUser } = options;

    const [isEditing, setIsEditing] = useState(false);

    const handleCompanyInfoUpdate = (values) => {
        companyInfoUpdateAction(values);
        setIsEditing(false);
    };

    const toggleEdit = () => {
        setIsEditing((prev) => !prev);
    };

    return (
        <Container className={classes.container}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography variant="h4" component="h1" gutterBottom className={classes.infoTitle}>
                    Account Information
                </Typography>
                <IconButton onClick={toggleEdit} hidden={isGuestUser} aria-label="edit" style={{ marginBottom: '16px' }}>
                    <EditIcon />
                </IconButton>
            </Box>
            <Formik
                initialValues={defaultInitialValues|| {}}
                enableReinitialize={true}
                onSubmit={(values) => {
                    handleCompanyInfoUpdate(values);
                }}
            >
                {(formikProps) =>
                    <FormComponent
                        {...formikProps}
                        organizationInfo={defaultInitialValues}
                        isGuestUser={isGuestUser}
                        isEditing={isEditing}
                        signUpAction={signUpAction}
                    />
                }
            </Formik>
        </Container>
    );
}
export default AccountInformation;